import { render, staticRenderFns } from "./MoleculeCommentSection.vue?vue&type=template&id=135625c0&scoped=true"
import script from "./MoleculeCommentSection.vue?vue&type=script&lang=js"
export * from "./MoleculeCommentSection.vue?vue&type=script&lang=js"
import style0 from "./MoleculeCommentSection.vue?vue&type=style&index=0&id=135625c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135625c0",
  null
  
)

export default component.exports